import { render, staticRenderFns } from "./TripHistory.vue?vue&type=template&id=66e84ac0&scoped=true&"
import script from "./TripHistory.vue?vue&type=script&lang=js&"
export * from "./TripHistory.vue?vue&type=script&lang=js&"
import style0 from "./TripHistory.vue?vue&type=style&index=0&id=66e84ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e84ac0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VNavigationDrawer,VPagination})
